module.exports = __webpack_public_path__ + "img/engine-status-amber.b8acebc4.svg";